import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Grid, Button, ButtonToolbar, Col, Table } from 'react-bootstrap';

import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { MessageAPI } from '../../../api/datamanager/MessageAPI';
import { PlatformAPI } from '../../../api/datamanager/PlatformAPI';
import { LineAPI } from '../../../api/datamanager/LineAPI';
import { PathStopAPI } from '../../../api/datamanager/PathStopAPI';
import { MessageForm } from './MessageForm';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { PaginationBuilder } from '../../PaginationBuilder';
import { SearchBar } from '../../SearchBar';
import { SearchHelper } from '../../helpers/SearchHelper';
import { TitleRow } from '../../TitleRow';
import { storage, TOKEN_INFO } from '../../../app/Storage';
import { decode } from 'jsonwebtoken';
import { TableButton } from '../../TableButton';
import { EditionSelector } from '../../EditionSelector';

export class Messages extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            messageSelected: undefined,
            availableLines: [],
            availablePathStops: [],
            availablePlatforms: [],
            availableProviders: [],
            isAT: false,

            loadingEdition: false,
            loadingMessages: true,
            loadingLines: true,
            loadingPathStops: true,
            loadingPlatforms: true,
            showMessageFormModal: false,
            showErrorModal: false,
            showExecutingModal: false,
            filter: "",
            currentPage: 1,
            elementsPerPage: 10,

            lineInputError: null,
            stopInputError: null,
            providerInputError: null,
            startDateInputError: null,
            endDateInputError: null,
            platformInputError: null,
            textInputError: null,
            typeInputError: null,

            alertTitle: undefined,
            icon: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            alertArgument: undefined,
            executingMessage: <LoadingSpinner />,
            executingStyle: "primary",
            exectuingIcon: "transfer",
            executingTitle: "A Executar...",
            title: ''
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);

        this.getPlatforms();
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        this.setState({
            loadingEdition: true
        });
    }
    
    endUpdate() {
        this.setState({
            loadingEdition: false
        });
    }
    
    updateNetwork() {
        this.setState({
            loadingMessages: true,
            loadingLines: true,
            loadingPathStops: true
        }, () => {
            this.checkUserRole(this.context.edition);
        });
    }

    //---------------

    getMessages(providerId) {
        return MessageAPI.list(providerId)
            .catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showErrorModal: true
                })
            });
    }

    getMessagesCreateadByAtWithoutProvider() {
        return MessageAPI.loadCreatedByAt()
            .catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showErrorModal: true
                })
            });
    }

    getLines(edition, providerId) {
        return LineAPI.list(edition.network, providerId)
            .catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                })
            });
    }

    getPathStops(edition, providerId) {
        return PathStopAPI.list(edition.network, providerId)
            .catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                })
            });
    }

    getPlatforms() {
        PlatformAPI.list()
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    availablePlatforms: data,
                    loadingPlatforms: false
                });
            }).catch((err) => {
                this.setState({
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    errorLoading: true,
                    showExecutingModal: false,
                    showErrorModal: true
                })
            });
    }

    checkUserRole(edition) {
        let { availableProviders } = this.state;
        let tokenInfo = storage.get(TOKEN_INFO);

        if (typeof tokenInfo !== 'undefined') {
            var json = JSON.parse(tokenInfo);
            tokenInfo = Object.assign({}, json);
        }

        if (tokenInfo.id_token) {
            let idToken = decode(tokenInfo.id_token);

            if (idToken.providers) {

                let auxProviders = idToken.providers.split(';');
                auxProviders.forEach(p =>
                    -1 === availableProviders.findIndex(p1 => p1.id === p.split(':')[0]) ? availableProviders.push({ id: p.split(':')[0], name: p.split(':')[1] }) : null
                );

                let totalMessages = [];
                let totalLines = [];
                let totalPathStops = [];

                let promisesMessages = [];
                let promisesLines = [];
                let promisesPathStops = [];

                //If everything has already been loaded, this means that the user cancelled some operatior, therefore we only need to get messages
                if (!(this.state.loadingLines && this.state.loadingMessages && this.state.loadingPathStops)) {
                    promisesMessages.push(this.getMessagesCreateadByAtWithoutProvider());
                    availableProviders.forEach(p => {
                        promisesMessages.push(this.getMessages(p.id));
                    });

                    Promise.all(promisesMessages).then(result => {
                        result.forEach(m =>
                            totalMessages = totalMessages.concat(JSON.parse(m))
                        );

                        this.setState({
                            messageSelected: undefined,
                            messages: totalMessages,
                            loadingMessages: false,
                            showMessageFormModal: false,
                            lineInputError: null,
                            stopInputError: null,
                            providerInputError: null,
                            startDateInputError: null,
                            endDateInputError: null,
                            platformInputError: null,
                            textInputError: null,
                            typeInputError: null
                        });
                    });
                } else {

                    promisesMessages.push(this.getMessagesCreateadByAtWithoutProvider());
                    availableProviders.forEach(p => {
                        promisesMessages.push(this.getMessages(p.id));
                        promisesLines.push(this.getLines(edition, p.id));
                        promisesPathStops.push(this.getPathStops(edition, p.id));
                    });

                    Promise.all(promisesMessages).then(result => {
                        result.forEach(m =>
                            totalMessages = totalMessages.concat(JSON.parse(m))
                        );

                        this.setState({
                            loadingMessages: false,
                            messages: totalMessages,
                        });
                    });

                    Promise.all(promisesLines).then(result => {
                        result.forEach(l =>
                            totalLines = totalLines.concat(JSON.parse(l))
                        );
                        this.setState({
                            loadingLines: false,
                            availableLines: totalLines
                        });
                    });

                    Promise.all(promisesPathStops).then(result => {
                        result.forEach(ps =>
                            totalPathStops = totalPathStops.concat(JSON.parse(ps))
                        );
                        this.setState({
                            loadingPathStops: false,
                            availablePathStops: totalPathStops
                        });
                    });

                    this.setState({
                        isAT: true,
                        availableProviders
                    });
                }
            } else {
                this.getMessages('')
                    .then(data => this.setState({
                        loadingMessages: false,
                        showMessageFormModal: false,
                        lineInputError: null,
                        stopInputError: null,
                        providerInputError: null,
                        startDateInputError: null,
                        endDateInputError: null,
                        platformInputError: null,
                        textInputError: null,
                        typeInputError: null,
                        messages: JSON.parse(data)
                    }));

                this.getLines(edition, '')
                    .then(data => this.setState({
                        loadingLines: false,
                        availableLines: JSON.parse(data)
                    }));

                this.getPathStops(edition, '')
                    .then(data => this.setState({
                        loadingPathStops: false,
                        availablePathStops: JSON.parse(data)
                    }));
            }
        }
    }

    //---------------

    updateMessageValue = (e, value) => {
        let { messageSelected, availableLines, availablePathStops, availablePlatforms, availableProviders } = this.state;

        if ('provider' === value) {
            if ('Selecione um operador' === e.target.value) {
                messageSelected[value] = undefined;
                messageSelected.line = undefined;
                messageSelected.stop = undefined;
                messageSelected.coordX = 0;
                messageSelected.coordY = 0;
            } else {
                messageSelected.provider = availableProviders.filter(p => p.id === e.target.value)[0];
            }
        } else if ('line' === value) {
            if ('Selecione uma linha' === e.target.value || 'Selecione um operador' === e.target.value) {
                messageSelected[value] = undefined;
                messageSelected.stop = undefined;
                messageSelected.coordX = 0;
                messageSelected.coordY = 0;
            } else {
                let newLine = availableLines.filter(line => line.id === parseInt(e.target.value, 10))[0];
                //If the line selected is new, reset the selected stop and coordinates
                if (undefined !== messageSelected.line && messageSelected.line.id !== newLine.id) {
                    messageSelected.stop = undefined;
                    messageSelected.coordX = 0;
                    messageSelected.coordY = 0;
                }
                messageSelected[value] = newLine;
            }
        }
        else if ('stop' === value) {
            if ('Selecione uma linha' === e.target.value || 'Selecione uma paragem' === e.target.value) {
                messageSelected[value] = undefined;
                messageSelected.coordX = 0;
                messageSelected.coordY = 0;
            } else {
                let pathStop = availablePathStops.filter(ps => ps.stop.id === parseInt(e.target.value, 10))[0];
                messageSelected[value] = pathStop.stop;
                messageSelected.coordX = pathStop.stop.latitude;
                messageSelected.coordY = pathStop.stop.longitude;
            }
        }
        else if ('startDate' === value || 'endDate' === value) {
            messageSelected[value] = e;
        }
        else if ('platform' === value) {
            if (e.length > messageSelected.platforms.length) {
                let platformToAdd = availablePlatforms.filter(plat => plat.id === parseInt(e[e.length - 1].value, 10))[0];
                if (messageSelected.platforms.findIndex(plat => plat.id === platformToAdd.id) === -1) {
                    messageSelected.platforms.push(platformToAdd);
                }
            }
            else {
                let newPlatformsArray = messageSelected.platforms.filter(plat => e.findIndex(p => p.value === plat.id) !== -1);
                messageSelected.platforms = newPlatformsArray;
            }
        }
        else if ('circleEdited' === value) {
            let newCircle = e.layers._layers[Object.keys(e.layers._layers)[0]];
            if (undefined !== newCircle) {
                messageSelected.radius = Number(newCircle._mRadius.toFixed(2));
                messageSelected.coordX = newCircle._latlng.lat;
                messageSelected.coordY = newCircle._latlng.lng;
            }
        }
        else if ('dblClick' === value) {
            messageSelected.coordX = e.latlng.lat;
            messageSelected.coordY = e.latlng.lng;
        }
        else {
            messageSelected[value] = e.target.value;
        }

        this.setState({
            messageSelected
        });
    }

    formattedDate = (date) => {
        if (date !== null && date !== undefined) {
            var aux = date.substring(0, 10)
            var newString = aux.split("-")
            var finalString = ""
            for (var i = newString.length - 1; i >= 0; i--) {
                finalString += newString[i] + '-';
            }
            return finalString.substring(0, 10);
        }
    }

    //---------------

    handleCreateClick = () => {
        this.setState({
            messageSelected: {
                provider: '', line: '', stop: '', platforms: [], type: '', text: '', version: '', httpLink: '', startDate: '', endDate: '', createdBy: '', coordX: 0, coordY: 0, radius: 20
            },
            showMessageFormModal: true,
            title: 'Criar'
        })
    }

    handleEditClick = (message) => {
        this.setState({
            messageSelected: message,
            showMessageFormModal: true,
            title: 'Editar'
        })
    }

    handleDeleteClick = (message) => {
        this.setState({
            messageSelected: message,
            showDeleteModal: true,
            alertTitle: "Aviso",
            alertMessage: `Tem a certeza que pretende eliminar a mensagem "${message.text}"?`,
            icon: 'alert',
            alertStyle: "warning"
        })
    }

    onChangePage = (page) => {
        this.setState({
            currentPage: page
        });
    }

    onChangeElementsPerPage = (elements) => {
        this.setState({
            elementsPerPage: elements
        });
    }

    saveMessage = () => {
        if (this.validInput()) {
            this.setState({
                showExecutingModal: true
            }, () => {
                const { edition } = this.context;

                if (this.state.messageSelected.id === undefined) {
                    MessageAPI.create(this.state.messageSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                showMessageFormModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Mensagem criada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            });
                            this.checkUserRole(edition);
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                showMessageFormModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            });
                            this.checkUserRole(edition);
                        });
                } else {
                    MessageAPI.update(this.state.messageSelected.id, this.state.messageSelected)
                        .then(() => {
                            this.setState({
                                showExecutingModal: false,
                                showMessageFormModal: false,
                                alertTitle: "Sucesso",
                                alertMessage: 'Mensagem alterada com sucesso.',
                                alertStyle: 'success',
                                icon: 'ok',
                                showErrorModal: true
                            });
                            this.checkUserRole(edition);
                        }).catch((err) => {
                            this.setState({
                                showExecutingModal: false,
                                showMessageFormModal: false,
                                alertTitle: "Erro",
                                alertMessage: err.message,
                                alertStyle: 'danger',
                                icon: 'remove',
                                showErrorModal: true
                            });
                            this.checkUserRole(edition);
                        });
                }
            });
        }
    }

    deleteMessage = (isToExecute) => {
        if (isToExecute) {
            this.setState({
                showDeleteModal: false,
                showExecutingModal: true
            }, () => {
                const { edition } = this.context;

                MessageAPI.delete(this.state.messageSelected.id)
                    .then(() => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Sucesso",
                            alertMessage: 'Mensagem removida com sucesso.',
                            icon: 'ok',
                            alertStyle: 'success',
                            showErrorModal: true
                        });
                        this.checkUserRole(edition);
                    }).catch((err) => {
                        this.setState({
                            showExecutingModal: false,
                            alertTitle: "Erro",
                            alertMessage: err.message,
                            alertStyle: 'danger',
                            icon: 'remove',
                            showErrorModal: true
                        });
                        this.checkUserRole(edition);
                    })
            })
        }

        this.setState({
            showDeleteModal: false
        })
    }

    //---------------

    validInput() {
        let { startDateInputError, endDateInputError, textInputError, typeInputError, platformInputError } = this.state;
        let errors = 0;

        startDateInputError = null;
        endDateInputError = null;
        textInputError = null;
        typeInputError = null;
        platformInputError = null;

        if ("" === this.state.messageSelected.startDate || null === this.state.messageSelected.startDate) {
            startDateInputError = 'error';
            errors++;
        }

        if ("" !== this.state.messageSelected.endDate && (this.state.messageSelected.endDate < this.state.messageSelected.startDate)) {
            endDateInputError = 'error';
            errors++;
        }

        if ("" === this.state.messageSelected.text) {
            textInputError = 'error';
            errors++;
        }

        if ("" === this.state.messageSelected.type) {
            typeInputError = 'error';
            errors++;
        }

        if (0 === this.state.messageSelected.platforms.length) {
            platformInputError = 'error';
            errors++;
        }

        this.setState({
            startDateInputError,
            endDateInputError,
            textInputError,
            typeInputError,
            platformInputError
        });

        return errors > 0 ? false : true;
    }

    //---------------

    onSearch(filter) {
        this.setState({
            filter: filter
        });
    }

    clearError = () => {
        this.setState({
            showErrorModal: false,
            alertTitle: undefined,
            alertMessage: undefined,
            alertStyle: undefined,
            icon: undefined,
        })
    }

    //---------------

    renderPlatformNames(platforms) {
        let platformNames;
        platforms.map(p =>
            platformNames = undefined === platformNames ? `${p.name}` : `${platformNames}, ${p.name}`
        );

        return platformNames;
    }

    renderMessagesTable(messages) {
        let { filter } = this.state;
        const messageFilter = SearchHelper.search({
            filter: filter,
            data: messages,
            fields: ["provider.name", "line.code", "stop.name", "text", "platforms", "startDate", "endDate", "creationDate", "version", "type", "createdBy", "coordX", "coordY", "radius", "httpLink"],
            callbackComparison: [{ "startDate": this.formattedDate }, { "endDate": this.formattedDate }, { "creationDate": this.formattedDate }, { "platforms": this.renderPlatformNames }]
        });

        const totalPages = PaginationHelper.getTotalPages(messageFilter.length, this.state.elementsPerPage);
        const activePage = totalPages < this.state.currentPage ? totalPages : this.state.currentPage;
        const messagesToRender = messageFilter.sort((a, b) => a.creationDate !== b.creationDate ? a.creationDate < b.creationDate ? -1 : 1 : 0)
            .slice((activePage - 1) * this.state.elementsPerPage, activePage * this.state.elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <Table responsive striped hover >
                    <thead>
                        <tr>
                            <th>Operador</th>
                            <th>Linha</th>
                            <th>Paragem</th>
                            <th>Texto</th>
                            <th>Plataforma</th>
                            <th>Data de Início</th>
                            <th>Data de Fim</th>
                            <th>Data de Criação</th>
                            <th>Versão</th>
                            <th>Tipo</th>
                            <th>Criado Por</th>
                            <th>Coordenada X</th>
                            <th>Coordenada Y</th>
                            <th>Raio</th>
                            <th>Hiperligação</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            messagesToRender.map((message, idx) =>
                                <tr key={`message-${idx}`}>
                                    <td>{undefined !== message.provider ? message.provider.name : ''}</td>
                                    <td>{undefined !== message.line ? message.line.code : ''}</td>
                                    <td>{undefined !== message.stop ? message.stop.name : ''}</td>
                                    <td>{message.text}</td>
                                    <td>{0 !== message.platforms.length ? this.renderPlatformNames(message.platforms) : ''}</td>
                                    <td>{this.formattedDate(message.startDate)}</td>
                                    <td>{this.formattedDate(message.endDate)}</td>
                                    <td>{this.formattedDate(message.creationDate)}</td>
                                    <td>{message.version}</td>
                                    <td>{message.type}</td>
                                    <td>{message.createdBy}</td>
                                    <td>{message.coordX}</td>
                                    <td>{message.coordY}</td>
                                    <td>{message.radius}</td>
                                    <td>{message.httpLink}</td>
                                    <td>
                                        <ButtonToolbar className="pull-right">
                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.handleEditClick(message)} />
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.handleDeleteClick(message)} />
                                        </ButtonToolbar>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table >
                <PaginationBuilder currentPage={this.state.currentPage} elementsPerPage={this.state.elementsPerPage} dataLength={messageFilter.length} onChangePage={this.onChangePage}
                    onChangeElementsPerPage={this.onChangeElementsPerPage} />
            </Grid>
        );
    }

    render() {
        if (!this.state.errorLoading) {
            const { edition } = this.context;
            const { loadingPlatforms, loadingMessages, loadingLines, loadingPathStops } = this.state;

            let contents = loadingPlatforms || loadingMessages || loadingLines || loadingPathStops
                ? <LoadingSpinner />
                : this.renderMessagesTable(this.state.messages);

            return (

                <div>
                    <EditionSelector />

                    <TitleRow title="Mensagens" showSeparator={true}>
                        <Col className="padding-0" xs={2} sm={1} md={4}>
                            <ButtonToolbar className="pull-right title-row-col-btns">
                                <Button onClick={this.handleCreateClick}> CRIAR </Button>
                            </ButtonToolbar>
                        </Col>
                        <Col className="padding-0" xs={10} sm={11} md={8}>
                            <div className="search-bar">
                                <SearchBar onSearch={(a) => this.onSearch(a)} />
                            </div>
                        </Col>
                    </TitleRow>

                    <div className="margin-top-15">
                        {contents}
                    </div>

                    <MessageForm show={this.state.showMessageFormModal} messageSelected={this.state.messageSelected} availableLines={this.state.availableLines} availablePathStops={this.state.availablePathStops}
                        availablePlatforms={this.state.availablePlatforms} isAT={this.state.isAT} availableProviders={this.state.availableProviders} startDateInputError={this.state.startDateInputError}
                        endDateInputError={this.state.endDateInputError} textInputError={this.state.textInputError} typeInputError={this.state.typeInputError} platformInputError={this.state.platformInputError}
                        title={this.state.title} onChangeValue={this.updateMessageValue} onSave={this.saveMessage} onHide={() => this.checkUserRole(edition)} />

                    <HandleDialog show={this.state.showDeleteModal} title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} onExit={this.deleteMessage} />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                    <HandleMessage show={this.state.showExecutingModal} title={this.state.executingTitle} message={this.state.executingMessage} icon={this.state.exectuingIcon} style={this.state.executingStyle}
                        onHide={this.clearError} small noButtons />
                </div>
            )
        } else {
            return (
                <div>
                    <LoadingSpinner />
                    <HandleMessage title={this.state.alertTitle} message={this.state.alertMessage} icon={this.state.icon} style={this.state.alertStyle} show={this.state.showErrorModal} onHide={this.clearError} />
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/messages/Messages.js